<script lang="ts">
	import {afterUpdate, beforeUpdate, onMount} from 'svelte';

	let element: HTMLElement;
	let active: boolean;

	function scrollToBottomIfActive() {
		if (active) {
			scrollToBottom();
		}
	}

	function scrollToBottom() {
		element.scrollTo(0, element.scrollHeight);
	}

	function updateActiveFlag() {
		active = element && ((element.offsetHeight + element.scrollTop) > (element.scrollHeight - 20));
	}

	onMount(scrollToBottom);
	beforeUpdate(updateActiveFlag);
	afterUpdate(scrollToBottomIfActive);

</script>


<div bind:this={element} style="overflow-y: scroll;">
	<slot/>
</div>